// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ac54ea3a","22":"657738d2","27":"efa38323","375":"568460e7","408":"1f00b6e8","754":"7f1cde92"}[chunkId] + ".chunk.js";
};